import { useTranslation } from 'react-i18next';
import { PhoneIncoming, PhoneOutgoing, Globe } from 'lucide-react';

export function Card({ className = '', children, padded = true, style }) {
    return (
        <div
            style={style}
            className={[
                'bg-white border border-cream-200 rounded-lg shadow-[0_1px_0_rgba(28,26,23,0.02)]',
                padded ? 'p-6' : '',
                className,
            ].filter(Boolean).join(' ')}
        >
            {children}
        </div>
    );
}

export function Empty({ icon: Icon, title, description, action }) {
    return (
        <div className="text-center py-24 px-6 relative">
            {Icon && (
                <Icon
                    size={56}
                    strokeWidth={1}
                    className="text-cream-300 mx-auto mb-6"
                    aria-hidden="true"
                />
            )}
            <h3 className="heading-display text-3xl font-semibold text-ink-900 mb-3 tracking-tight">
                {title}
            </h3>
            {description && (
                <p className="text-[15px] text-ink-500 max-w-md mx-auto leading-relaxed">
                    {description}
                </p>
            )}
            {action && <div className="mt-8">{action}</div>}
        </div>
    );
}

export function StatusDot({ kind = 'success', label }) {
    const map = {
        success: 'bg-success-500/80',
        warn: 'bg-warn-500/80',
        danger: 'bg-danger-500/80',
        idle: 'bg-ink-300',
    };
    return (
        <span className="inline-flex items-center gap-1.5">
            <span className={['inline-block size-1.5 rounded-full', map[kind] || map.idle].join(' ')} />
            <span className="text-xs text-ink-500">{label}</span>
        </span>
    );
}

export function DirectionChip({ direction }) {
    const { t } = useTranslation('common');
    // 三態：進線 (inbound) / 網頁 webcall (web) / 外撥 (其他)
    // icon + 顏色承載語意，文字標籤跟著（長英文/泰文 whitespace-nowrap 防折行、不爆版）
    const kind = direction === 'inbound' ? 'inbound' : direction === 'web' ? 'web' : 'outbound';
    const style = {
        inbound: 'bg-success-100 text-success-500',
        web: 'bg-warn-100 text-warn-500',
        outbound: 'bg-accent-50 text-accent-700',
    }[kind];
    const Icon = { inbound: PhoneIncoming, web: Globe, outbound: PhoneOutgoing }[kind];
    const label = t(`dir_${kind}`);
    return (
        <span
            className={[
                'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap',
                style,
            ].join(' ')}
            title={label}
            aria-label={label}
        >
            <Icon size={11} strokeWidth={2} className="shrink-0" />
            {label}
        </span>
    );
}
